"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceDataT = exports.DeviceData = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const tracker_data_js_1 = require("../../../solarxr-protocol/data-feed/tracker/tracker-data.js");
const device_id_js_1 = require("../../../solarxr-protocol/datatypes/device-id.js");
const hardware_info_js_1 = require("../../../solarxr-protocol/datatypes/hardware-info/hardware-info.js");
const hardware_status_js_1 = require("../../../solarxr-protocol/datatypes/hardware-info/hardware-status.js");
/**
 * Describes all possible information about a hardware device. For example, a
 * vive tracker is a  single hardware device, and a slime tracker with two
 * extensions is a single hardware device but two trackers.
 */
class DeviceData {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsDeviceData(bb, obj) {
        return (obj || new DeviceData()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsDeviceData(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new DeviceData()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    id(obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new device_id_js_1.DeviceId()).__init(this.bb_pos + offset, this.bb) : null;
    }
    customName(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    /**
     * Mostly-static info about the device hardware
     */
    hardwareInfo(obj) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? (obj || new hardware_info_js_1.HardwareInfo()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    /**
     * General info about the status of the device
     */
    hardwareStatus(obj) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? (obj || new hardware_status_js_1.HardwareStatus()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    /**
     * Info about all trackers attached to this device
     */
    trackers(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? (obj || new tracker_data_js_1.TrackerData()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    trackersLength() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    static startDeviceData(builder) {
        builder.startObject(5);
    }
    static addId(builder, idOffset) {
        builder.addFieldStruct(0, idOffset, 0);
    }
    static addCustomName(builder, customNameOffset) {
        builder.addFieldOffset(1, customNameOffset, 0);
    }
    static addHardwareInfo(builder, hardwareInfoOffset) {
        builder.addFieldOffset(2, hardwareInfoOffset, 0);
    }
    static addHardwareStatus(builder, hardwareStatusOffset) {
        builder.addFieldOffset(3, hardwareStatusOffset, 0);
    }
    static addTrackers(builder, trackersOffset) {
        builder.addFieldOffset(4, trackersOffset, 0);
    }
    static createTrackersVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startTrackersVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static endDeviceData(builder) {
        const offset = builder.endObject();
        return offset;
    }
    unpack() {
        return new DeviceDataT((this.id() !== null ? this.id().unpack() : null), this.customName(), (this.hardwareInfo() !== null ? this.hardwareInfo().unpack() : null), (this.hardwareStatus() !== null ? this.hardwareStatus().unpack() : null), this.bb.createObjList(this.trackers.bind(this), this.trackersLength()));
    }
    unpackTo(_o) {
        _o.id = (this.id() !== null ? this.id().unpack() : null);
        _o.customName = this.customName();
        _o.hardwareInfo = (this.hardwareInfo() !== null ? this.hardwareInfo().unpack() : null);
        _o.hardwareStatus = (this.hardwareStatus() !== null ? this.hardwareStatus().unpack() : null);
        _o.trackers = this.bb.createObjList(this.trackers.bind(this), this.trackersLength());
    }
}
exports.DeviceData = DeviceData;
class DeviceDataT {
    constructor(id = null, customName = null, hardwareInfo = null, hardwareStatus = null, trackers = []) {
        this.id = id;
        this.customName = customName;
        this.hardwareInfo = hardwareInfo;
        this.hardwareStatus = hardwareStatus;
        this.trackers = trackers;
    }
    pack(builder) {
        const customName = (this.customName !== null ? builder.createString(this.customName) : 0);
        const hardwareInfo = (this.hardwareInfo !== null ? this.hardwareInfo.pack(builder) : 0);
        const hardwareStatus = (this.hardwareStatus !== null ? this.hardwareStatus.pack(builder) : 0);
        const trackers = DeviceData.createTrackersVector(builder, builder.createObjectOffsetList(this.trackers));
        DeviceData.startDeviceData(builder);
        DeviceData.addId(builder, (this.id !== null ? this.id.pack(builder) : 0));
        DeviceData.addCustomName(builder, customName);
        DeviceData.addHardwareInfo(builder, hardwareInfo);
        DeviceData.addHardwareStatus(builder, hardwareStatus);
        DeviceData.addTrackers(builder, trackers);
        return DeviceData.endDeviceData(builder);
    }
}
exports.DeviceDataT = DeviceDataT;
